/**
 * Desc:
 * Created Date: Tuesday, September 10th 2024, 6:39:46 pm
 * Author: jim Li
 * -----
 * Last Modified: Tue May 13 2025
 * Modified By: jim Li
 */

export default {
  Tag_Common: {
    Shi: '是',
    Fou: '否',
    QiYon: '启用',
    TingYon: '停用',
    Fu: '复',
    Dan: '单',
    Nong: '浓',
    DaiRu: '带入',
    Tian: '天',
    XiaoShi: '小时',
    FenZhong: '分钟',
    FenZhong_10: '10分钟',
    FenZhong_15: '15分钟',
    FenZhong_20: '20分钟',
    FenZhong_30: '30分钟',
    FenZhong_60: '60分钟',
    XuanZe: '选择',
    Yi: '一',
    Er: '二',
    San: '三',
    Si: '四',
    Wu: '五',
    Liu: '六',
    Ri: '日',
    You: '有',
    Wu_Y: '无',
    Zhou_Yi: '周一',
    Zhou_Er: '周二',
    Zhou_San: '周三',
    Zhou_Si: '周四',
    Zhou_Wu: '周五',
    Zhou_Liu: '周六',
    Zhou_Ri: '周日',
    AR: '领养证明书',
    BC: '香港出生证明书',
    CD: '领事团身份证',
    DI: '香港特别行政区签证身份书',
    EC: '豁免证明书 (或称豁免登记证明书)',
    ED: '电子医疗纪录文件',
    ID: '香港身份证',
    MD: '澳门身份证',
    OC: '中华人民共和国发出之其他旅游证件',
    OP: '其他国家 / 地区发出之旅游证件',
    OW: '单程证',
    RE: '担保书 (行街纸)',
    RP: '香港特别行政区回港证',
    TW: '双程证',
    You_Zhi: '由',
    Zhi_You: '至',
    You_KuCun: '有库存',
    Wu_KuCun: '无库存',
    GongKai: '公开',
    Fei_GongKai: '非公开',
    GongYong: '公用',
    QuanLiang_PanDian: '全量盘点',
    BuFen_PanDian: '部分盘点',
    Fan: '反',
    Wei: '畏',
    Tong_DianHua: '同电话',
    Tong_Ming: '同名',
    Tong_ZhengJian: '同证件',
  },
}
